import React, { useState, useEffect } from 'react';
import {
  Checkbox,
  Divider,
  Modal,
  Button
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { getOrderPendingByBuyerId } from '../../services/Buyer';
import {
  getOrderPendingPackageList
} from '../../services/Order';
import { getListEnabled } from '../../services/Entity';
import { toThousands } from '../../utils/Numeric';
import { chkPallet } from '../../utils/Pallet';
export default React.forwardRef((props, ref) => {
  const { palletId, plan, onCloseCallback, onSaveCallback } = props;
  if (palletId === undefined || !plan) return;

  const [limit, setLimit] = useState(0);
  const [portContainer, setPortContainer] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [orders, setOrders] = useState([]);
  const [packages, setPackages] = useState(plan.packages.filter(x => x.pallet_id === palletId));
  useEffect(() => {
    getOrderPendingByBuyerId(plan.buyer_id).then(data => setOrders(data));
    getListEnabled('fm_port_container').then(data => setPortContainer(data));
  }, []);

  useEffect(() => {
    const limit = (portContainer.find(x => x.container_id === plan.container_id && x.port_id === plan.destination_port_id) || {}).weight;
    setLimit(limit);
  }, [portContainer])

  const onChangeSelectedOrder = (values) => {
    values.forEach(x => {
      const find = allPackages.find(y => y.order_id === x);
      if (!find) {
        getOrderPendingPackageList(x).then(data1 => {
          const data2 = [];
          data1.forEach(x => {
            x.weight = x.unit_weight * x.count * 0.001;
            if (!data2.find(p => p.id === x.pallet_id) && x.pallet_id > -1) {
              data2.push({ id: x.pallet_id, supplier_id: x.supplier_id });
            }
          });
          const temp = [].concat(allPackages);
          temp.push({
            order_id: x,
            packages: data1,
            pallets: data2
          });
          setAllPackages(temp);
        });
      }
    })
    setSelectedOrders(values);
  }

  const deletePackage = (id) => {
    let temp = [].concat(packages);
    temp = temp.filter(x => x.id !== id);
    setPackages(temp);
  }
  const onCheck = (checked, carton) => {
    let temp = [].concat(packages);
    if (checked) {
      temp.push({ ...carton, flag: 'new' });
    } else {
      temp = temp.filter(x => x.id !== carton.id);
    }
    setPackages(temp);
  }
  const totalWeights = () => {
    let total_weights = 0;
    for (let i = 0; i < packages.length; i++) {
      total_weights += (packages[i].weight || 0);
    }
    return total_weights.toFixed(2);
  }

  const totalContainerWeights = () => {
    let total_weights = 0;
    for (let i = 0; i < plan.packages.length; i++) {
      total_weights += (plan.packages[i].weight || 0);
    }
    packages.filter(x => x.flag === 'new').map(pkg => {
      total_weights += (pkg.weight || 0);
    })
    return total_weights.toFixed(2);
  }
  const total = {
    containerWeight: totalContainerWeights(),
    totalWeight: totalWeights()
  }
  const chk = chkPallet(packages);

  const onSave = () => {
    if (total.containerWeight > limit) {
      Modal.error({
        title: '发货总重量异常',
        content: "当前总重量[" + total.containerWeight + "KG]超过港口-集装箱限重 [" + limit + "KG]",
      });
      return;
    }
    if (palletId > -1) {
      if (chk.status > 1) {
        Modal.error({
          title: '托盘数据',
          content: '当前发货区域存在不符合标准的托盘！',
        });
        return;
      }

      if (chk.status === 1) {
        Modal.confirm({
          title: '确认?',
          icon: <ExclamationCircleOutlined />,
          content: <strong>
            当前发货区域存在超重的托盘，是否继续生成发货计划？</strong>,
          okText: '是',
          centered: true,
          okType: 'danger',
          cancelText: '否',
          onOk() {
            if (onSaveCallback) {
              onSaveCallback(plan.id, packages.filter(x => x.flag === 'new').map(y => ({ id: y.id, pallet_id: palletId === 0 ? new Date().getTime() : palletId })))
            }
          },
          onCancel() {
            console.log('Cancel');
          },
        });
        return;
      }
    }
    Modal.confirm({
      title: '确认',
      icon: <ExclamationCircleOutlined />,
      content: <strong>确定保存当前的数据吗</strong>,
      okText: '是',
      centered: true,
      okType: 'danger',
      cancelText: '否',
      onOk() {
        if (onSaveCallback) {
          onSaveCallback(plan.id, packages.filter(x => x.flag === 'new').map(y => ({ id: y.id, pallet_id: palletId === 0 ? new Date().getTime() : palletId })))
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });

  }
  return (
    <div>
      <div style={{ backgroundColor: '#dcdef5', padding: '0.5rem 1rem' }}>
        客户名称：<strong>{plan.buyer_name}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
        目的港口：<strong>{plan.destination_port_name}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
        集装箱型：<strong>{plan.container_name} (限重<span>{limit}</span>KG)</strong>&nbsp;&nbsp;&nbsp;&nbsp;
        当前集装箱总重：<strong><span style={{ color: total.containerWeight > limit ? 'red' : 'green' }}>{total.containerWeight}</span>KG</strong>
      </div>
      <div style={{ backgroundColor: '#dcdef5', padding: '0.5rem 1rem' }}>
        待发货订单：<Checkbox.Group
          options={
            orders.filter(o => o.destination_port_id === plan.destination_port_id).map(x =>
              ({ label: <strong>{`#${x.po_code}`}</strong>, value: x.id }))
          }
          onChange={onChangeSelectedOrder}
        />
      </div>
      <div style={{ padding: '0.5rem 1rem' }}>
        {palletId > 0 && <span>该托盘已有产品：</span>} {palletId > 0 && chk.content}
        {palletId === -1 && <span>已有散箱产品：</span>}
        {palletId === 0 && <span><strong>添加新托盘</strong></span>} {palletId === 0 && chk.content}
        <br />
        <table style={{ border: '2px solid #f0f0f0' }} className="table">
          <thead style={{ backgroundColor: '#fff' }}>
            <tr>
              <td className="th" rowSpan="2" width="380px" >产品号</td>
              <td className="th" rowspan="2" >供应商</td>
              <td className="th" rowspan="2" >P.O</td>
              <td className="th" rowspan="2" >订单号</td>
              <td className="th" rowspan="2" >箱数</td>
              <td className="th2" colspan="2">数量(件)</td>
              <td className="th" rowSpan="2">重量<br />(千克)</td>
              <td className="th" rowSpan="2">总重量<br />(千克)</td>
            </tr>
            <tr>
              <td align="center" style={{ paddingTop: 0, paddingBottom: 0 }} className="th">件数/箱</td>
              <td align="center" style={{ paddingTop: 0, paddingBottom: 0 }} className="th">总件数</td>
            </tr>
          </thead>
          <tbody>
            {packages.map((carton, index) => {
              return <tr>
                <td className="td">
                  {carton.goods_spec_name}&nbsp;
                        {carton.size}&nbsp;&nbsp;
                        {carton.goods_name}&nbsp;&nbsp;
                        {carton.flag === 'new' && <Button size="small" onClick={() => deletePackage(carton.id)} danger icon={<DeleteOutlined />} />}
                </td>
                <td className="td" align="center">
                  {carton.supplier_name}
                </td>
                <td className="td" align="center" >
                  {carton.po_code}
                </td>
                <td className="td" align="center" >
                  {carton.no}
                </td>
                <td align="right" className="td">{toThousands(carton.carton_count)}</td>
                <td align="right" className="td">{toThousands(carton.count_per_carton)}</td>
                <td align="right" className="td">{toThousands(carton.carton_count * carton.count_per_carton)}</td>
                <td align="right" className="td">{toThousands(carton.weight.toFixed(2))}</td>
                {
                  index === 0 && <td align="right" className="td" rowspan={packages.length}>{toThousands(total.Weight)}</td>
                }
              </tr>
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding: '0.5rem 1rem' }}>
        选择要添加的产品：<br />
        <table style={{ border: '2px solid #f0f0f0' }} className="table">
          <thead style={{ backgroundColor: '#fff' }}>
            <tr>
              <td className="th" rowSpan="2" >#</td>
              <td className="th" rowSpan="2" width="380px" >产品号</td>
              <td className="th" rowspan="2" >供应商</td>
              <td className="th" rowspan="2" >P.O</td>
              <td className="th" rowspan="2" >订单号</td>
              <td className="th" rowspan="2" >箱数</td>
              <td className="th2" colspan="2">数量(件)</td>
              <td className="th" rowSpan="2">重量<br />(千克)</td>
              <td className="th" rowSpan="2">总重量<br />(千克)</td>
            </tr>
            <tr>
              <td align="center" style={{ paddingTop: 0, paddingBottom: 0 }} className="th">件数/箱</td>
              <td align="center" style={{ paddingTop: 0, paddingBottom: 0 }} className="th">总件数</td>
            </tr>
          </thead>
          <tbody>
            {allPackages.filter(x => selectedOrders.find(y => y === x.order_id)).map((order) => {
              return order.packages.filter(x => !packages.find(y => y.id === x.id)).map((carton, index) => {
                return <tr>
                  <td className="td" align="center"><Checkbox checked={false} onChange={(e) => onCheck(e.target.checked, carton)} /></td>
                  <td className="td">
                    {carton.goods_spec_name}&nbsp;
                        {carton.size}&nbsp;&nbsp;
                        {carton.goods_name}
                  </td>
                  <td className="td" align="center">
                    {carton.supplier_name}
                  </td>
                  <td className="td" align="center" >
                    {carton.po_code}
                  </td>
                  <td className="td" align="center" >
                    {carton.no}
                  </td>
                  <td align="right" className="td">{toThousands(carton.carton_count)}</td>
                  <td align="right" className="td">{toThousands(carton.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(carton.carton_count * carton.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(carton.weight.toFixed(2))}</td>
                  {/* {
                    index === 0 && <td align="right" className="td" rowspan={packages.length}>{toThousands(total.totalWeight)}</td>
                  } */}
                  <td align="right" className="td"></td>
                </tr>
              })
            })}

          </tbody>
        </table>
      </div>
      <Divider />
      <div className="page-footer">
        <div>

        </div>
        <div style={{ paddingRight: '1rem' }}>
          <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
          &nbsp;&nbsp;&nbsp;
          <Button onClick={onSave} disabled={packages.filter(x => x.flag === 'new').length === 0} type="primary" icon={<CheckOutlined />}>保 存</Button>
        </div>
      </div>
    </div>
  );
});